@if (_main.showNotificationBar) {
  <div class="overlay position-fixed vh-100 vw-100 top-0 start-0">
    <div class="position-absolute top-0 end-0 bg-white h-100 w-100 mxw-450 p-3 notification-wrapper">
      <div class="notify-header">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h4 class="fw-700 m-0">Notifications</h4>
          <img src="assets/images/icons/cross-icon.svg" class="hw-30 border p-1 rounded-circle cursor"
            (click)="toggleNotificationBar()" alt="Close">
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <p class="fs-14 fw-400 m-0 cursor me-2 px-2 rounded-pill"
                [ngClass]="selected_nav === NavType.All ? 'text-white bg-success' : 'text-muted'"
              (click)="updateNotifications(NavType.All)">All</p>
              <p class="fs-14 fw-400  m-0 cursor me-2 px-2 rounded-pill"
                [ngClass]="selected_nav === NavType.Unread ? 'text-white bg-success' : 'text-muted'"
              (click)="updateNotifications(NavType.Unread)">Unread</p>
              <div class="btn-group" dropdown>
                <span id="button-animated" class="fs-14 fw-400 cursor px-2 rounded-pill" dropdownToggle  (click)="updateNotifications(NavType.Type)" [ngClass]="selected_nav === NavType.Type ? 'text-white bg-success' : 'text-muted'"
                  >
                  {{type}}
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="height: 16px;" class="toggle-arrow">
                    <path
                      d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                      [attr.fill]="selected_nav === NavType.Type ? '#fff' : '#000'" />
                    </svg>
                  </span>
                  <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu">
                    @for (type of notificationTypes; track type) {
                      <li
                        class="dropdown-item cursor"
                        (click)="updateNotifications(NavType.Type, type)">
                        {{type.label}}
                      </li>
                    }
                  </ul>
                </div>
              </div>
              @if (_main.unread_count && _main.unread_count > 0) {
                <p class="m-0 fs-14 fw-600 text-success cursor" (click)="readNotification()">
                  Mark all as read
                </p>
              }
            </div>
            <div class="d-flex w-100 align-items-center input_field p-0 rounded-pill overflow-hidden mt-3 mb-4">
              <span class="d-flex justify-content-center align-items-center ps-2 hw-40 h-100">
                <img src="assets/images/icons/search-icon.svg" alt="">
              </span>
              <input class="input_field m-0 border-0 flex-fill" type="text" trim="true" tabindex="-1"
                (keydown.enter)="page_number = 1;filter=0; getNotifications();selected_nav=0;" required
                [(ngModel)]="search_string" placeholder="Search" (input)="onInputChange()">
                @if (search_string) {
                  <span class="d-flex justify-content-center align-items-center pe-2 hw-40 h-100 cursor"
                    >
                    <img src="assets/images/icons/cross-icon.svg" class="cursor" alt="" (click)="search_string = ''; getNotifications()">
                  </span>
                }
              </div>
            </div>
            <div class="notify-list overflow-auto hisde-scroll-bar">
              @if (notifications.length > 0) {
                <div (scroll)="scrollHandler()">
                  @for (item of notifications; track item; let i = $index) {
                    <div class="notification-item border-top p-2 cursor position-relative pe-4"
                      (click)="navToNotification(item)" [ngClass]="{'lightgreen-bg': item.read_at == null}">
                      @if (item.read_at == null) {
                        <span class="position-absolute hw-8 top-0 mt-2 end-0 me-2 rounded-circle d-block bg-success"></span>
                      }
                      <h4 class="fs-16 fw-600 m-0">{{item.title || 'No Title'}}</h4>
                      <p class="fs-14 fw-400 text-muted m-0">{{item.message || 'No Message'}}</p>
                      <span class="fs-12 fw-400 text-muted">
                        <img src="assets/images/icons/clock-icon.svg" class="me-2">{{item.show_sent_at || 'No Date'}}
                      </span>
                    </div>
                  }
                  <div id="infinite-scroller"></div>
                </div>
              } @else {
                <div class="d-flex align-item-center flex-column">
                  <p class="text-center"><img class="hw-200" src="assets/images/icons/no-notification.svg"></p>
                  <p class="text-center fs-14 fw-400 text-muted">{{filter == 2 ? 'No unread or new notifications found.' : 'No notifications found.'}}</p>
                </div>
              }
            </div>
          </div>
        </div>
      }
